import { dateToTimestamp } from 'shared/helpers/parsers/date';
import { removeCommasAndParse } from 'shared/helpers/parsers/text';

export const parseUpdateDraftFinalPayment = payment => ({
  fundsType: payment.fundsType.value,
  requestedFinalPaymentDate: dateToTimestamp(payment.requestedFinalPaymentDate),
  paymentAmount: removeCommasAndParse(payment.paymentAmount),
  additionalInfo: payment.additionalInfo,
  relatedLot: payment.relatedLot.value,
});
